import React from "react";

const STATUS_STYLES = {
  ACTIVE: { tone: "success", label: "Active" },
  SUCCESSFUL: { tone: "success", label: "Successful" },
  SCHEDULED: { tone: "warning", label: "Scheduled" },
  TRIAL: { tone: "warning", label: "Trial" },
  RESERVED: { tone: "warning", label: "Pending payment" },
  PAUSED: { tone: "secondary", label: "Paused" },
  RELEASED: { tone: "secondary", label: "Released" },
  EXPIRED: { tone: "secondary", label: "Expired" },
  DEPLETED: { tone: "danger", label: "Depleted" },
  FAILED: { tone: "danger", label: "Failed" },
  REVERTED: { tone: "danger", label: "Reverted" },
};

/**
 * Status pill matching the badge style used by the other list tables
 * (e.g. organizations/components/subscriber-data-table.jsx).
 */
const PromoStatusBadge = ({ status }) => {
  if (!status) return "N/A";
  const { tone, label } = STATUS_STYLES[String(status).toUpperCase()] || { tone: "secondary", label: status };

  return <div className={`badge rounded-pill fw-medium fs-sm bg-${tone} text-${tone} bg-opacity-25`}>{label}</div>;
};

export default PromoStatusBadge;
